import axios from "axios";
import React from "react";
import "../styles/singleproduct.css"
import Addcart from "../components/addtocart";
import Chatbutton from '../components/chatbutton';
import UploadImage from "../components/multer";
import '../styles/chatbutton.css';
import { NotificationContainer } from 'react-notifications'
import 'react-notifications/lib/notifications.css';
import Addreview from "../components/reviews";
import Reviewheader from "../components/reviewstar";
import DeleteReview from "../components/DeleteReviewButton";
import DeleteProduct from "../components/deleteproductbutton";
const url = window.location.href;
const params = (new URL(url)).searchParams;
const id = params.get("productid");


export default class SingleProductPage extends React.Component {
  state = {
    posts: [],
    reviews: []
  }


  componentDidMount() {

    axios.get(`https://shoppee-clone.herokuapp.com/product/${id}`)
      .then(res => {
        const posts = res.data;
        this.setState({ posts });
        return axios.get(`https://shoppee-clone.herokuapp.com/product/${id}/reviews`);
      })
      .then((res) => {
        console.log(res.data); //View in Browser's Developer Tools
        const reviews = res.data;
        this.setState({ reviews });
       
    
      })
  }

  render() {

    return (

      <div>
        {this.state.posts.map(post =>
          <div class=" col d-flex justify-content-center ">
            <div className="row no-gutters">
              <img className="main-img" src={'images/' + post.image} />

              <aside className="col-sm-7">
                <article className="p-5">
                  <h3 className="title mb-3">{post.name}</h3>

                  <div className="mb-3">
                    <var className="price h3 text-success">
                      <span className="currency">SGD </span>
                      <span className="num">${post.price}</span>
                    </var>
                  </div>
                  <dl>
                    <dt>Description</dt>
                    <dd>
                      <p className="text-dark">{post.description}</p>
                    </dd>
                  </dl>
                </article>
              </aside>
            </div>
          </div>)}
        <Addcart></Addcart>
        <DeleteProduct></DeleteProduct>
        <Addreview></Addreview>
        <Reviewheader />
        
      


        <DeleteReview></DeleteReview>
        <UploadImage></UploadImage>
        <Chatbutton ></Chatbutton>
        <NotificationContainer />
      </div>
    )

  }

}

